import { BoxSlotParticipationSchema } from "@/modules/boxSlot/boxSlotTypes"
import { UserDtoSchema } from "@/modules/profile/userProfile/userDto"
import { MAX_255_CHARACTERS } from "@/typings/formik"
import { z } from "zod"

export const BoxProgramSlotDefaultSettingsDtoSchema = z
  .object({
    duration: z.number().nullable(),
    participantLimit: z.number().nullable(),
    location: z.string().max(MAX_255_CHARACTERS).nullable(),
    participation: BoxSlotParticipationSchema.nullable(),
    allowMultiBooking: z.boolean(),
    assignedStaffMembers: UserDtoSchema.array().nullable(),
    dropinsAccepted: z.boolean(),
    trialsAccepted: z.boolean(),
  })
  .meta({ id: "BoxProgramSlotDefaultSettingsDtoSchema" })

export type BoxProgramSlotDefaultSettingsDto = z.infer<typeof BoxProgramSlotDefaultSettingsDtoSchema>

export const BoxProgramSlotDefaultSettingsInputDtoSchema = z
  .object({
    duration: z.number().nullable(),
    participantLimit: z.number().nullable(),
    location: z.string().max(MAX_255_CHARACTERS).nullable(),
    participation: BoxSlotParticipationSchema.nullable(),
    allowMultiBooking: z.boolean(),
    assignedStaffMembers: z.array(z.string()).nullable(),
    dropinsAccepted: z.boolean(),
    trialsAccepted: z.boolean(),
  })
  .meta({ id: "BoxProgramSlotDefaultSettingsInputDtoSchema" })

export type BoxProgramSlotDefaultSettingsInputDto = z.infer<typeof BoxProgramSlotDefaultSettingsInputDtoSchema>
